/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, FileData, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from './request';
// @ts-ignore
import makeRequestHook from './makeRequestHook';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://yapi.yishou.com/mock/104' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = '' as any;
const dataKey_0_0_0_0 = 'data' as any;

export interface ObsFormUploadDataRequest {
  /**
   * app类型:{ys:ys,ys_app:一手app,pda:pda,baob:爆版,buyer:采购版}
   */
  app_type: string;
  /**
   * 模块
   */
  module?: string;
}

export type ObsFormUploadDataResponse = {
  /**
   * ak值
   */
  access_key_id?: string;
  /**
   * policy值
   */
  policy?: string;
  /**
   * 签名
   */
  signature?: string;
  /**
   * 成功返回状态码
   */
  success_action_status?: string;
  /**
   * 域名
   */
  domain?: string;
  /**
   * 域名
   */
  end_point?: string;
  /**
   * 桶名
   */
  bucket?: string;
}[];

type ObsFormUploadDataRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.yishou.com/mock/104',
    '',
    '',
    '/obs/obs_form_upload_data',
    'data',
    string,
    'app_type' | 'module',
    false
  >
>;

const obsFormUploadDataRequestConfig: ObsFormUploadDataRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/obs/obs_form_upload_data',
  method: Method.GET,
  requestHeaders: { app_id: 'yishou-test', sign: '', timestamp: '1626186121' },
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['app_type', 'module'],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: 'object',
    required: ['app_type'],
    properties: {
      app_type: {
        type: 'string',
        description: 'app类型:{ys:ys,ys_app:一手app,pda:pda,baob:爆版,buyer:采购版}',
      },
      module: { type: 'string', description: '模块' },
    },
  },
  responseDataJsonSchema: {
    type: 'array',
    items: {
      type: 'object',
      properties: {
        access_key_id: { type: 'string', description: 'ak值', example: 'xxxxx' },
        policy: {
          type: 'string',
          description: 'policy值',
          example: 'eyJleHBpcmF0aW9uIjoiMjAyMS0wNy0xM1QxMD',
        },
        signature: { type: 'string', description: '签名', example: 'xxxx' },
        success_action_status: { type: 'string', description: '成功返回状态码', example: '201' },
        domain: { type: 'string', description: '域名', example: 'https://img4.yishouapp.com' },
        end_point: { type: 'string', description: '域名', example: 'end_point' },
        bucket: { type: 'string', description: '桶名', example: 'yishou-img' },
      },
    },
  },
  requestFunctionName: 'obsFormUploadData',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

export const obsFormUploadData = /*#__PURE__*/ (
  requestData: ObsFormUploadDataRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ObsFormUploadDataResponse>(
    prepare(obsFormUploadDataRequestConfig, requestData),
    ...args,
  );
};

obsFormUploadData.requestConfig = obsFormUploadDataRequestConfig;

export const useObsFormUploadData = /*#__PURE__*/ makeRequestHook<
  ObsFormUploadDataRequest,
  ObsFormUploadDataRequestConfig,
  ReturnType<typeof obsFormUploadData>
>(obsFormUploadData);

export interface ObsTokenRequest {
  /**
   * app类型:{ys:ys,ys_app:一手app,pda:pda,baob:爆版app,buyer:采购版,pss-api:爆版服务端,pss-manage:爆版后台}
   */
  app_type: string;
  /**
   * 模块:{log:日志模块}
   */
  module?: string;
}

export type ObsTokenResponse = {
  /**
   * 临时ak值
   */
  access_key_id?: string;
  /**
   * 临时sk值
   */
  access_key_secret?: string;
  /**
   * token
   */
  security_token?: string;
  /**
   * 上传路径
   */
  prefix_path?: string;
  /**
   * 域名
   */
  domain?: string;
  /**
   * end_point
   */
  end_point?: string;
  /**
   * 到期时间
   */
  expire_date?: string;
  /**
   * 桶名
   */
  bucket?: string;
}[];

type ObsTokenRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.yishou.com/mock/104',
    '',
    '',
    '/obs/obs_token',
    'data',
    string,
    'app_type' | 'module',
    false
  >
>;

const obsTokenRequestConfig: ObsTokenRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/obs/obs_token',
  method: Method.GET,
  requestHeaders: { app_id: 'yishou-test', timestamp: '1626186121' },
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['app_type', 'module'],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: 'object',
    required: ['app_type'],
    properties: {
      app_type: {
        type: 'string',
        description:
          'app类型:{ys:ys,ys_app:一手app,pda:pda,baob:爆版app,buyer:采购版,pss-api:爆版服务端,pss-manage:爆版后台}',
      },
      module: { type: 'string', description: '模块:{log:日志模块}' },
    },
  },
  responseDataJsonSchema: {
    type: 'array',
    items: {
      type: 'object',
      properties: {
        access_key_id: { type: 'string', description: '临时ak值', example: 'xxxxx' },
        access_key_secret: {
          type: 'string',
          description: '临时sk值',
          example: 'eyJleHBpcmF0aW9uIjoiMjAyMS0wNy0xM1QxMD',
        },
        security_token: {
          type: 'string',
          description: 'token',
          example: 'ggpjbi1ub3J0aC00SYV7ImFj',
        },
        prefix_path: { type: 'string', description: '上传路径', example: 'obs/ys/xxx' },
        domain: { type: 'string', description: '域名', example: 'https://img4.yishouapp.com' },
        end_point: { type: 'string', description: 'end_point', example: 'end_point' },
        expire_date: { type: 'string', description: '到期时间', example: 'end_point' },
        bucket: { type: 'string', description: '桶名', example: 'yishou-img' },
      },
    },
  },
  requestFunctionName: 'obsToken',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

export const obsToken = /*#__PURE__*/ (
  requestData: ObsTokenRequest,
  ...args: UserRequestRestArgs
) => {
  return request<ObsTokenResponse>(prepare(obsTokenRequestConfig, requestData), ...args);
};

obsToken.requestConfig = obsTokenRequestConfig;

export const useObsToken = /*#__PURE__*/ makeRequestHook<
  ObsTokenRequest,
  ObsTokenRequestConfig,
  ReturnType<typeof obsToken>
>(obsToken);

export interface TranscodingRequest {
  /**
   * app类型:{ys:ys,ys_app:一手app,pda:pda,baob:爆版app,buyer:采购版,pss-api:爆版服务端,pss-manage:爆版后台}
   */
  app_type: string;
  /**
   * obs视频原url
   */
  url: string;
  /**
   * 模块:{log:日志模块}
   */
  module: string;
}

export interface TranscodingResponse {
  /**
   * 转码后的视频url
   */
  url?: string;
}

type TranscodingRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.yishou.com/mock/104',
    '',
    '',
    '/mpc/transcoding',
    'data',
    string,
    string,
    false
  >
>;

const transcodingRequestConfig: TranscodingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/mpc/transcoding',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: 'object',
    required: ['app_type', 'url', 'module'],
    properties: {
      app_type: {
        type: 'string',
        description:
          'app类型:{ys:ys,ys_app:一手app,pda:pda,baob:爆版app,buyer:采购版,pss-api:爆版服务端,pss-manage:爆版后台}',
      },
      url: { type: 'string', description: 'obs视频原url' },
      module: { type: 'string', description: '模块:{log:日志模块}' },
    },
  },
  responseDataJsonSchema: {
    type: 'object',
    properties: { url: { type: 'string', description: '转码后的视频url' } },
  },
  requestFunctionName: 'transcoding',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

export const transcoding = /*#__PURE__*/ (
  requestData: TranscodingRequest,
  ...args: UserRequestRestArgs
) => {
  return request<TranscodingResponse>(prepare(transcodingRequestConfig, requestData), ...args);
};

transcoding.requestConfig = transcodingRequestConfig;

export const useTranscoding = /*#__PURE__*/ makeRequestHook<
  TranscodingRequest,
  TranscodingRequestConfig,
  ReturnType<typeof transcoding>
>(transcoding);

/* prettier-ignore-end */
